export default "__VITE_ASSET__J6heo_cp__"